export class DodajZespolModel {
    idProjektu: string;
    idWykonawcow: Array<string> = new Array();
    nazwaZespolu: string;
}